import React, { useId } from 'react';

/**
 * Astra — the face of Stratia's counselor (founder pick, 2026-08-06).
 *
 * Per aspera ad astra: through the hard parts, to the stars. The mark is a
 * warm star-orb in the brand greens with an amber glint and one small
 * orbiting spark — alive but calm. Entirely inline SVG + CSS keyframes
 * (see index.css: astra-breathe / astra-orbit), zero external assets, and
 * both animations are disabled under prefers-reduced-motion.
 */
export default function AstraAvatar({ size = 28, className = '' }) {
    // A UNIQUE gradient id per instance. It was hardcoded 'astraOrb', so the
    // moment a second Astra mark appeared on a page (the sidebar dock plus the
    // Major Map's Ask Astra card, 2026-08-10) the document carried duplicate
    // ids and the later svg's fill resolved to the earlier one's def. The orb
    // painted nothing, and because the star is near-white it vanished against
    // the card — leaving a single amber dot where Astra should be.
    const orbId = `astraOrb-${useId().replace(/:/g, '')}`;
    return (
        <span
            className={`astra-avatar inline-flex shrink-0 ${className}`}
            style={{ width: size, height: size }}
            aria-hidden="true"
            data-testid="astra-avatar"
        >
            <svg viewBox="0 0 40 40" width={size} height={size} role="img">
                {/* the orb */}
                <defs>
                    <radialGradient id={orbId} cx="35%" cy="30%" r="80%">
                        <stop offset="0%" stopColor="#3E8158" />
                        <stop offset="55%" stopColor="#2D6B45" />
                        <stop offset="100%" stopColor="#1A4D2E" />
                    </radialGradient>
                </defs>
                <circle cx="20" cy="20" r="18" fill={`url(#${orbId})`} />
                {/* the star — four soft points, breathing gently */}
                <path
                    className="astra-star"
                    d="M20 8.5 L22.6 17.4 L31.5 20 L22.6 22.6 L20 31.5 L17.4 22.6 L8.5 20 L17.4 17.4 Z"
                    fill="#EAF6EC"
                />
                {/* the amber glint */}
                <circle cx="26.5" cy="13.5" r="1.8" fill="#F5B942" />
                {/* one small spark on a slow orbit */}
                <g className="astra-orbiter">
                    <circle cx="20" cy="3.6" r="1.6" fill="#8FD4A8" />
                </g>
            </svg>
        </span>
    );
}
